export * from './User';

export enum FooterType
{
    Comment,
    File
}

